<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<section class="metric-info-dialog">
	<div class="metric-info-callout">
		<h4>What is this?</h4>
		<p>{{ metricInfo.whatIsThis }}</p>
	</div>

	<div class="metric-info-table-wrapper">
		<table class="metric-info-table">
			<thead>
				<tr>
					<th scope="col">Range</th>
					<th scope="col">Assessment</th>
				</tr>
			</thead>
			<tbody>
				@for (item of metricInfo.ranges; track $index) {
					<tr>
						<td>{{ getRangeLabel(item) }}</td>
						<td>{{ item.assessment }}</td>
					</tr>
				}
			</tbody>
		</table>
	</div>
</section>
